// DetailQuickfacts — section 3. Canonical detail.html lines 414–435.
//
// Subtype-aware: residential populates rooms / area / kitchen / floor
// / bathrooms; land/commercial populate their own quickfacts. Branch
// is screen-local — no registry, no dispatch table.

function DetailQuickfacts({ property }) {
  const residential = property.residential || null;
  const land = property.land || null;
  const commercial = property.commercial || null;

  return (
    <section className="detail-quickfacts">
      <div className="container">
        <ul className="quickfact-list" aria-label="Ключові характеристики">
          {residential ? (
            <>
              <li>
                <i className="fa-solid fa-door-open" aria-hidden="true" />
                <span>
                  <strong>{residential.rooms ?? "—"}</strong> кімн.
                </span>
              </li>
              <li>
                <i className="fa-solid fa-vector-square" aria-hidden="true" />
                <span>
                  <strong>{residential.total_area_m2 ?? "—"}</strong>{" "}
                  м<sup>2</sup>
                </span>
              </li>
              <li>
                <i className="fa-solid fa-utensils" aria-hidden="true" />
                <span>
                  кухня{" "}
                  <strong>{residential.kitchen_area_m2 ?? "—"}</strong>{" "}
                  м<sup>2</sup>
                </span>
              </li>
              <li>
                <i className="fa-solid fa-stairs" aria-hidden="true" />
                <span>
                  <strong>{residential.floor ?? "—"}</strong>/
                  {residential.total_floors ?? "—"} поверх
                </span>
              </li>
              <li>
                <i className="fa-solid fa-bath" aria-hidden="true" />
                <span>
                  <strong>{residential.bathrooms ?? "—"}</strong> санвузол
                </span>
              </li>
              {residential.has_parking ? (
                <li>
                  <i
                    className="fa-solid fa-square-parking"
                    aria-hidden="true"
                  />
                  <span>Парковка</span>
                </li>
              ) : null}
              {residential.has_balcony ? (
                <li>
                  <i className="fa-solid fa-mountain-sun" aria-hidden="true" />
                  <span>Балкон</span>
                </li>
              ) : null}
            </>
          ) : null}

          {land ? (
            <>
              <li>
                <i className="fa-solid fa-vector-square" aria-hidden="true" />
                <span>
                  <strong>{land.area_m2 ?? "—"}</strong> м<sup>2</sup>
                </span>
              </li>
              {land.has_road_access ? (
                <li>
                  <i className="fa-solid fa-road" aria-hidden="true" />
                  <span>Під&apos;їзна дорога</span>
                </li>
              ) : null}
              {land.has_utilities ? (
                <li>
                  <i className="fa-solid fa-bolt" aria-hidden="true" />
                  <span>Комунікації</span>
                </li>
              ) : null}
            </>
          ) : null}

          {commercial ? (
            <>
              <li>
                <i className="fa-solid fa-vector-square" aria-hidden="true" />
                <span>
                  <strong>{commercial.total_area_m2 ?? "—"}</strong>{" "}
                  м<sup>2</sup>
                </span>
              </li>
              <li>
                <i className="fa-solid fa-stairs" aria-hidden="true" />
                <span>
                  <strong>{commercial.floor ?? "—"}</strong> поверх
                </span>
              </li>
            </>
          ) : null}
        </ul>

        <div className="program-badges" aria-label="Державні програми">
          <span
            className={
              property.has_housing_program
                ? "program-badge program-badge--on"
                : "program-badge program-badge--off"
            }
          >
            <i
              className={
                property.has_housing_program
                  ? "fa-solid fa-check-circle"
                  : "fa-solid fa-circle-xmark"
              }
              aria-hidden="true"
            />
            єОселя
          </span>
          <span
            className={
              property.has_recovery_program
                ? "program-badge program-badge--on"
                : "program-badge program-badge--off"
            }
          >
            <i
              className={
                property.has_recovery_program
                  ? "fa-solid fa-check-circle"
                  : "fa-solid fa-circle-xmark"
              }
              aria-hidden="true"
            />
            єВідновлення
          </span>
        </div>
      </div>
    </section>
  );
}

export default DetailQuickfacts;
